// CUSTOM (Portela 2026-10-22): formatTime em português. O `formatTime` do pacote
// `@chatwoot/utils` devolve a duração em INGLÊS ("2 Hr 58 Min", "45 Min 30 Sec",
// "1 Day 5 Hr") — usado nos cards de Tempo de Primeira Resposta/Resolução e no eixo
// dos gráficos de relatório. Como é node_module, não dá overlay direto; então
// replico a MESMA lógica com siglas pt (h/min/s/d) e troco o import nos consumidores.
// Siglas (não palavras) por decisão do dono: "inglês só sigla, o resto português".
export const formatTime = timeInSeconds => {
  let str = '';
  if (timeInSeconds >= 60 && timeInSeconds < 3600) {
    const min = Math.floor(timeInSeconds / 60);
    str = `${min} min`;
    const sec = min === 60 ? 0 : Math.floor(timeInSeconds % 60);
    return str + (sec > 0 ? ` ${sec} s` : '');
  }
  if (timeInSeconds >= 3600 && timeInSeconds < 86400) {
    const hr = Math.floor(timeInSeconds / 3600);
    str = `${hr} h`;
    const min =
      timeInSeconds % 3600 < 60 ? 0 : Math.floor((timeInSeconds % 3600) / 60);
    return str + (min > 0 ? ` ${min} min` : '');
  }
  if (timeInSeconds >= 86400) {
    const day = Math.floor(timeInSeconds / 86400);
    str = `${day} d`;
    const hr =
      timeInSeconds % 86400 < 3600
        ? 0
        : Math.floor((timeInSeconds % 86400) / 3600);
    return str + (hr > 0 ? ` ${hr} h` : '');
  }
  return `${Math.floor(timeInSeconds)} s`;
};
